<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Produto</div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <form action>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="Name">
                          <span class="required">*</span> Nome:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          id="Name"
                          class="form-control"
                          v-model="produtos.produto_nome"
                          placeholder=""
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="Name">
                          <span class="required">*</span> Categoria Produto:
                        </label>
                        <select
                          class="form-control"
                          v-model="produtos.categoria_produto_id"
                        >
                          <option
                            v-for="categoria in categorias"
                            :key="categoria.categoria_produto_id"
                            :value="categoria.categoria_produto_id"
                          >
                            {{ categoria.categoria_produto_nome }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="Name">
                          <span class="required">*</span> Quantidade de Produto:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="number"
                          id="Name"
                          class="form-control"
                          v-model="produtos.produto_quantidade"
                          placeholder=""
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="Name">
                          <span class="required">*</span> Tipo de Unidade de
                          Medida:
                        </label>
                        <select
                          class="form-control"
                          v-model="produtos.tipo_unidade_medida_id"
                        >
                          <option
                            v-for="tipo_unidade_medida in tipo_unidade_medidas"
                            :key="tipo_unidade_medida.tipo_unidade_medida_id"
                            :value="tipo_unidade_medida.tipo_unidade_medida_id"
                          >
                            {{ tipo_unidade_medida.tipo_unidade_medida_nome }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="Name">
                          <span class="required">*</span> Observação:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          id="Name"
                          class="form-control"
                          v-model="produtos.observacao"
                          placeholder=""
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="Name">
                          <span class="required">*</span> Status:
                        </label>
                        <select v-model="produtos.status" class="form-control">
                          <option :value="1">Ativo</option>
                          <option :value="0">Inativo</option>
                        </select>
                      </div>
                    </div>

                    <span class="required_fields">
                      <span class="required">*</span>
                      <strong>Campos obrigatórios</strong>
                    </span>
                    <div class="block text-right">
                      <router-link to="/produtos" class="btn btn-back mr-1">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                      <a class="btn btn-add" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  data() {
    return {
      produtos: {
        produto_nome: "",
        categoria_produto_id: "",
        produto_quantidade: "",
        tipo_unidade_medida_id: "",
        observacao: "",
        status: "",
      },
      categorias: [],
      tipo_unidade_medidas: [],
    };
  },
  computed: {},
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "produtos";

      if (self.produtos.produto_id) {
        self.produtos._method = "PUT";
        api += "/" + self.produtos.produto_id;
      }

      axios
        .post(api, self.produtos)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/produtos");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getProdutos: function (id) {
      const self = this;
      const api = self.$store.state.api + "produtos/" + id;

      axios
        .get(api)
        .then((response) => {
          self.produtos = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getCategoriaProduto: function () {
      const self = this;
      let api =
        self.$store.state.api + "categoria_produto?paginated=false&status=1";

      axios
        .get(api)
        .then((response) => {
          self.categorias = response.data.data;
          console.log(response.data.data);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getTipoUnidadeMedida: function () {
      const self = this;
      let api =
        self.$store.state.api + "tipo_unidade_medida?paginated=false&status=1";

      axios
        .get(api)
        .then((response) => {
          self.tipo_unidade_medidas = response.data.data;
          console.log(response.data.data);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;

    self.getCategoriaProduto();
    self.getTipoUnidadeMedida();

    let id = self.$route.params.id;
    if (id) {
      self.getProdutos(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}
.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}
.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important ;
}
.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>